export default __webpack_public_path__ + "static/media/Etape4_Bremandiere_Carrierecielouvert.efab57a8.jpg";